import { css } from '@spectrum-web-components/base';
const styles = css`
    :host{--spectrum-actionbar-popover-background-color:var(--system-action-bar-popover-background-color);--spectrum-actionbar-popover-border-color:var(--system-action-bar-popover-border-color)}
`;
export default styles;